import React from "react";
import { ArticleImage, Subhead } from "@bloomberg/media-ui-article";

import styles from "./styles.module.css";

export type ChartProps = {
    aspectRatio?: number | null;
    footnote: string;
    title: string;
    src: string;
    source: string;
    subtitle: string;
};

export default function Chart(props: ChartProps) {
    const { aspectRatio, footnote, title, src, source, subtitle } = props;

    return (
        <figure data-component="chart">
            {title && <Subhead className={styles.title}>{title}</Subhead>}
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
            <ArticleImage
                aspectRatio={aspectRatio}
                caption={footnote}
                credit={source}
                decoding="async"
                isExpandable
                isLazy
                src={src}
            />
        </figure>
    );
}
